// src/components/planning/EditReadingsModal/EditReadingsModal.tsx
import React from 'react';
import { Modal, Button, Alert, Spinner } from 'react-bootstrap';
import { EditReadingsModalProps } from './types';
import { useReadingsForm } from './useReadingsForm';
import { ReadingForm } from './ReadingForm';
import { ConfirmationModal } from './ConfirmationModal';

const EditReadingsModal: React.FC<EditReadingsModalProps> = ({
  show,
  onHide,
  readings,
  serviceId,
  liturgyName,
  liturgyDate,
  onUpdate
}) => {
  const {
    editedReadings,
    showConfirm,
    showAlert,
    alertMessage,
    alertVariant,
    isLoading,
    handleInputChange,
    handleUpdate,
    handleConfirmUpdate,
    setShowConfirm,
    setShowAlert
  } = useReadingsForm(readings, serviceId, onUpdate, onHide);

  return (
    <>
      <Modal show={show} onHide={onHide} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <div>
              Edit Readings
              <div className="small text-muted">
                {liturgyName} - {new Date(liturgyDate).toLocaleDateString()}
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ReadingForm
            editedReadings={editedReadings}
            onInputChange={handleInputChange}
          />
          
          {showAlert && (
            <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
              {alertMessage}
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleUpdate} disabled={isLoading}>
            {isLoading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
                />
                Updating...
              </>
            ) : (
              'Update Readings'
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      <ConfirmationModal
        show={showConfirm}
        onHide={() => setShowConfirm(false)}
        onConfirm={handleConfirmUpdate}
      />
    </>
  );
};

export default EditReadingsModal;